import { createApi } from "@reduxjs/toolkit/query/react";

import { Customer, DeviceKey } from "../../../types";
import axiosBaseQuery from "../rtk-query-axios.service";
import { APP_BASE_URL, GET_UNIVERSAL_DEVICE_KEYS, GET_UNIVERSAL_DEVICE_KEYS_ADD } from "../../../Common/EndPoints";

type CustomerPostParams = {
  params: {
    customerTitle?: string;
    zoneCode: string;
    divisionCode: string;
    stnCode: string;
  };
};

type CustomerPutParams = {
  params: {
    id: string;
    zonecode: string;
    divisioncode: string;
    Customertitle?: string;
    Customername?: string;
  };
};

type DeviceKeyManagementFormData = {
  alias: string;
  deviceType: string;
  key: string;
  ranges: Array<{
    cmin: string;
    cmax: string;
    wmin: string;
    wmax: string;
    unit: string;
  }>;
};

export const deviceKeysApi = createApi({
  reducerPath: "deviceKeysApi",
  baseQuery: axiosBaseQuery,
  tagTypes: ["device-keys"],
  endpoints: (builder) => ({
    getDeviceKeys: builder.query<DeviceKey[], void>({
      query: (params: any) => ({
        url: APP_BASE_URL + GET_UNIVERSAL_DEVICE_KEYS,
        method: "GET",
        params: {
          ...params,
          //   type: "e69d7c9d-e96a-477b-854d-eea8af0cd1d7",
          //   customerIds: [
          //     "50bc6230-3efb-11ed-818c-150801d2970c",
          //     "52d82a50-f153-11eb-b50e-0dffb4290152",
          //     "62d92a50-f153-11eb-b50e-0dffb4290152",
          //     "474df32c-4322-4d31-b086-58896bf997db",
          //     "62d82a50-f153-11eb-b50e-0dffb4290152",
          //     "72d82a50-f153-11eb-b50e-0dffb4290152",
          //     "63d82a50-f153-11eb-b50e-0dffb4290152",
          //     "64d82a50-f153-11eb-b50e-0dffb4290152",
          //     "65d82a50-f153-11eb-b50e-0dffb4290152",
          //     "62d42a50-f153-11eb-b50e-0dffb4290152",
          //     "62e82a50-f153-11eb-b50e-0dffb4290152",
          //     "958fa517-88c7-4d22-a796-5d39c444c6c2",
          //     "665983f5-c2ee-4ac1-a8a6-49fb80dd71d9",
          //     "48b9b0ab-fa93-4121-9e5a-ee253c5510cf",
          //     "8739d0c3-46c0-4a53-9628-ac3f1812d4c6",
          //     "fd51283a-a6b2-4e90-90fe-21bf44e85b71",
          //     "ed5431ff-05e7-40b6-9879-f29878d5f51a",
          //     "1ca0488e-4544-4143-93bd-05903cc8db7f",
          //     "9cd2ebea-9a59-4b43-8763-1f281866853d",
          //     "7860601b-0f87-448c-97ff-b444af033ce7",
          //     "eead1aad-db1b-42aa-bc73-2a5807128c79",
          //     "b4a3a378-c342-4232-9071-0b00df64727d",
          //     "c4105d88-15f8-4901-882a-5833c5e05806",
          //     "22e11e80-0562-4696-b7d3-0932dea6c82a",
          //     "02fe1fb3-58a0-402a-a426-5a6b3445a1d2",
          //     "bf36b409-a7cc-45a9-b50f-aaa56cbfabd7",
          //     "ce6221e3-47b3-4cb3-8bd4-7670f0b8bff1",
          //     "3a1863c0-58e7-11ed-a18c-f3994d59112a",
          //     "ce6221e3-47b3-4cb3-8bd4-7670f0b8bff1",
          //     "d0c08463-055b-4afc-ab4a-726e0543234e",
          //     "30e505fa-d811-4b50-9361-a61a2304b92f",
          //     "79cd00ba-780f-4692-a600-320607897907",
          //     "477b1637-1808-473a-a4a7-9a7162787062",
          //     "5e31f4cd-aae7-4df5-b06a-4dfad6c6e6d3",
          //     "fc596ffb-d9c9-47d9-99b3-f375501795b1",
          //     "1de2aaa7-7689-4c07-a022-cc522bb46d1a",
          //     "a5d46e16-5328-470b-a49c-4b83bbac834d",
          //     "7a9060f9-dc40-487b-b64f-839422232d06",
          //     "5217722c-7664-4398-b585-d2cc00c11dd8",
          //     "a2b14f8d-5c85-4022-b75a-6eb0d65cdc27",
          //     "1768448d-95e2-42a1-a504-38f1705e2c12",
          //     "25c6df9a-aac1-4337-8152-b088c8b82d1c",
          //     "c13182fd-981e-4017-8050-2b1009d1c5bb",
          //     "65da0883-3b4b-4d43-b342-6f289cc3d580",
          //     "55c2f25e-3e21-4371-b6cd-5d84c15655b6",
          //     "b2b23dee-4b9d-4b40-b75e-2de7018d180c",
          //     "7929d602-f5fd-431d-bed8-a488be3dff8a",
          //     "912d005a-3f55-4233-84b1-6049ba0e5db1",
          //     "064d3753-87d9-40b1-9906-b632c5bd1a50",
          //     "36d8c81e-bfd7-4d2e-b00e-6b2215054c12",
          //     "90322a62-54eb-40e4-85cc-3491e3f66b79",
          //     "8aaae707-8d4a-4d51-b9ab-0d1a40a39c45",
          //     "5a7ee3e6-4a12-42c0-bfa8-ab2bdeabb682",
          //     "1a6d6440-010c-48d6-8533-53cd4a61c99c",
          //     "0acb5945-0db0-49f7-99fb-86a6a9add8cb",
          //     "0b510940-8d8b-43d1-9dbe-694960820109",
          //     "5efe3dad-7eda-4d4e-a061-6b730bf2d4c3",
          //     "13130cae-a302-49e6-a5b0-9c67a2d461da",
          //     "ab57dc59-60bf-4110-b7e3-77a376bbc731",
          //     "ea9072fd-671d-4e68-9111-02844ff0ca62",
          //     "ec886efd-8e9d-44b8-a7cb-047301edf24b",
          //     "6e489b2e-bafa-4e6d-8322-e885efab8b21",
          //     "9640ec40-4f48-4b86-860e-91fb5250402f",
          //     "f4aa9f9e-3a45-449e-bdea-caf9d53f7dce",
          //     "1fe3f1ce-1e63-49c0-afc4-761cec630dea",
          //     "1b377fa8-557b-4369-9a4c-e7d49794a0ec",
          //     "467c295d-93e8-425c-9fa3-f056967ef0fb",
          //     "79cd00ba-780f-4692-a600-320607897907",
          //     "467c295d-93e8-425c-9fa3-f056967ef0fb",
          //     "50490f2c-4ed8-4775-b6b9-7a796381b433",
          //     "89049df1-9430-4dde-842a-30f150e80725",
          //     "608fa517-88c7-4d22-a796-5d39c444c6c2",
          //     "018fa517-88c7-4d22-a796-5d39c444c6c2",
          //     "028fa517-88c7-4d22-a796-5d39c444c6c2",
          //     "018fa517-88c7-4d22-a796-5d39c444c6c2",
          //     "028fa517-88c7-4d22-a796-5d39c444c6c2",
          //     "838fa517-88c7-4d22-a796-5d39c444c6c2",
          //     "808fa517-88c7-4d22-a796-5d39c444c6c2",
          //     "6ceaa022-8f99-4a80-94aa-2cf0393d177b",
          //     "858fa517-88c7-4d22-a796-5d39c444c6c2",
          //     "37c1d688-0af3-4142-8d16-2d276bf77fdc",
          //     "508fa517-88c7-4d22-a796-5d39c444c6c2",
          //     "818fa517-88c7-4d22-a796-5d39c444c6c2",
          //     "18a67330-6b2f-11ed-be89-35b8baf04d4d",
          //     "2f274b19-4b56-4b23-aaa4-3432e99288dd",
          //     "038fa517-88c7-4d22-a796-5d39c444c6c2",
          //     "1e98bab9-65a3-4409-a284-b9d5c9ee2366",
          //     "251d9771-f10d-4d30-a2b7-99e60c013003",
          //     "708fa517-88c7-4d22-a796-5d39c444c6c2",
          //     "848fa517-88c7-4d22-a796-5d39c444c6c2",
          //     "7cd56439-cbd8-43fb-a7ef-b05a527ac086",
          //     "99b82bf4-36c7-48b9-ba22-4bc6b8ac4c51",
          //     "42a49881-510e-4371-86a4-6f24a7358292",
          //     "a05bf212-c30a-41d2-90b1-897eeca88092",
          //     "b8e9daea-68bb-4ec4-94ee-35b281f1e20c",
          //     "7a990f42-b6fd-4a80-8064-b86f8d8dded4",
          //     "3152b5d9-6b38-4fbf-b76a-52059eee5204",
          //     "62f083b6-af45-4b2c-9549-88e456014add",
          //   ].join(","),
        },
      }),
      providesTags: ["device-keys"],
      transformResponse: (_response: { error: any; success: any; data: any[] }): DeviceKey[] =>
        _response.data.map((key, index) => {
          key.id = index;
          return key;
        }),
    }),
    postDeviceKey: builder.mutation<any, { params?: { customerIds?: string }; body: DeviceKeyManagementFormData }>({
      query: ({ params, body }: { params: { customerIds: string }; body: DeviceKeyManagementFormData }) => {
        return { url: APP_BASE_URL + GET_UNIVERSAL_DEVICE_KEYS_ADD, params, data: [body], method: "POST" };
      },
      invalidatesTags: ["device-keys"],
    }),
    editDeviceKey: builder.mutation<
      any,
      { params: { customerId: string; deviceType: string; key: string }; body: DeviceKeyManagementFormData }
    >({
      query: ({
        params,
        body,
      }: {
        params: { customerId: string; deviceType: string; key: string };
        body: DeviceKeyManagementFormData;
      }) => {
        return { url: APP_BASE_URL + GET_UNIVERSAL_DEVICE_KEYS_ADD, data: [body], params, method: "PUT" };
      },
      invalidatesTags: ["device-keys"],
    }),
    deleteDeviceKey: builder.mutation<any, { params: { customerId?: string; deviceType: string; key: string } }>({
      query: ({ params }: { params: { customerId?: string; deviceType: string; key: string } }) => {
        return { url: APP_BASE_URL + GET_UNIVERSAL_DEVICE_KEYS, params, method: "DELETE" };
      },
      invalidatesTags: ["device-keys"],
    }),
  }),
});
